import { CalendarCheck, ClipboardCheck, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Area } from './ClinicalFieldControls';
import { SectionCard } from './SectionCard';

interface PlanTreatmentSectionProps {
  plan: Record<string, string>;
  editable: boolean;
  onChange: (key: string, value: string) => void;
  onBlurSave: () => void;
}

/** Plan reorganized into 3 grouped cards instead of one flat list of 6 identical
 *  textareas — same fields/state/mutation as before. */
export function PlanTreatmentSection({
  plan,
  editable,
  onChange,
  onBlurSave,
}: PlanTreatmentSectionProps): JSX.Element {
  const { t } = useTranslation();
  const blur = editable ? onBlurSave : undefined;

  return (
    <div className="space-y-3">
      <SectionCard icon={ClipboardCheck} title={t('clinical.card_treatment')}>
        <Area
          label={t('clinical.f_treatment_notes')}
          value={plan.treatment_notes ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('treatment_notes', v)}
          onBlur={blur}
        />
        <Area
          label={t('clinical.f_medications_notes')}
          value={plan.medications_notes ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('medications_notes', v)}
          onBlur={blur}
        />
      </SectionCard>

      <SectionCard icon={Home} title={t('clinical.card_home_care')}>
        <Area
          label={t('clinical.f_diet_recommendations')}
          value={plan.diet_recommendations ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('diet_recommendations', v)}
          onBlur={blur}
        />
        <Area
          label={t('clinical.f_activity_restrictions')}
          value={plan.activity_restrictions ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('activity_restrictions', v)}
          onBlur={blur}
        />
      </SectionCard>

      <SectionCard icon={CalendarCheck} title={t('clinical.card_follow_up')}>
        <Area
          label={t('clinical.f_follow_up_notes')}
          value={plan.follow_up_notes ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('follow_up_notes', v)}
          onBlur={blur}
        />
        <Area
          label={t('clinical.f_owner_instructions')}
          value={plan.owner_instructions ?? ''}
          disabled={!editable}
          onChange={(v) => onChange('owner_instructions', v)}
          onBlur={blur}
        />
      </SectionCard>
    </div>
  );
}
